import '../styles/FAQ.css';

function FAQ() {
  const faqs = [
    {
      question: 'What does a Lean Six Sigma consultant do?',
      bullets: [
        'Identify waste and reduce process variation',
        'Solve root causes of operational problems',
        'Improve workflow, reduce defects, cut rework',
        'Shorten lead times and increase productivity',
        'Create more consistent ways of working',
        'Combine practical Lean methods with data-led problem solving'
      ]
    },
    {
      question: 'Do you work with SMEs and larger organisations?',
      bullets: [
        'Yes — we work with SMEs, growing businesses and larger organisations',
        'SMEs: improve productivity, reduce bottlenecks, create clearer processes',
        'Larger organisations: cross-functional improvement, operational excellence programmes',
        'Leadership coaching and capability building',
        'Approach adapted to your size, complexity and priorities'
      ]
    },
    {
      question: 'What\'s the difference between Lean and Lean Six Sigma?',
      bullets: [
        'Lean: improve flow, remove waste, reduce delays, deliver value efficiently',
        'Six Sigma: reduce variation, defects and recurring problems using data',
        'Lean Six Sigma: combines both to improve speed, quality, cost and consistency',
        'Applied practically so improvements are embedded and sustained'
      ]
    },
    {
      question: 'How can Lean consulting reduce operational costs?',
      bullets: [
        'Remove activities that don\'t add value',
        'Improve process flow and resource utilisation',
        'Less rework, fewer delays, reduced defects',
        'Lower inventory and improved productivity',
        'Better use of existing capacity',
        'Reduce cost without compromising quality or service'
      ]
    },
    {
      question: 'Do you provide Lean Six Sigma training?',
      bullets: [
        'Practical training and coaching for internal capability',
        'Lean awareness through to structured Six Sigma development',
        'Lean fundamentals, White Belt, Yellow Belt, Green Belt',
        '5S, root cause analysis, problem solving',
        'Process mapping, value stream mapping, daily management',
        'Tailored so teams learn methods they can apply immediately'
      ]
    },
    {
      question: 'Is Lean Six Sigma only for manufacturing?',
      bullets: [
        'No — widely used beyond manufacturing',
        'Applies to service, finance, healthcare, logistics, construction',
        'Technology, administration and professional services',
        'Any organisation with processes, delays, errors or inconsistent performance can benefit',
        'Approach adapted to suit your environment and objectives'
      ]
    },
    {
      question: 'How long does a typical engagement take?',
      bullets: [
        'Depends on scope, complexity and objectives',
        'Focused improvements: 6–12 weeks',
        'Larger transformation programmes: 6–18 months',
        'Clear timelines, milestones and success measures defined upfront'
      ]
    },
    {
      question: 'What kind of results can we expect?',
      bullets: [
        'Cost reductions of 15–40%',
        'Lead time reductions of 20–50%',
        'Quality/defect improvements of 30–70%',
        'Productivity gains of 20–35%',
        'Capability built so improvements are sustained and multiplied over time'
      ]
    }
  ];

  return (
    <div className="faq">
      {/* Header */}
      <section className="faq-header">
        <div className="faq-header-overlay"></div>
        <div className="faq-header-content">
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to common questions about Lean, Six Sigma and how we work</p>
        </div>
      </section>

      {/* FAQ Hero Image */}
      <section className="faq-hero-image">
        <img
          src="https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?w=1200&h=400&fit=crop"
          alt="Business team brainstorming session"
          className="faq-banner-img"
        />
      </section>

      {/* FAQs */}
      <section className="faq-content">
        <div className="faq-container">
          <ul className="faq-list">
            {faqs.map((faq, index) => (
              <li key={index} className="faq-item">
                <h3 className="faq-question-text">{faq.question}</h3>
                <ul className="faq-answer-bullets bullet-list">
                  {faq.bullets.map((bullet, i) => (
                    <li key={i}>{bullet}</li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Still have questions */}
      <section className="faq-contact">
        <div className="faq-contact-container">
          <h2>Still have questions?</h2>
          <p>Get in touch with our team to discuss your specific situation</p>
          <a href="/contact" className="cta-button">Contact Us</a>
        </div>
      </section>
    </div>
  );
}

export default FAQ;
